import React from 'react';
import styles from './WorksGrid.module.css';

const FilterBar = ({ filters, activeFilter, onFilterChange }) => {
  return (
    <div className={styles.filterBar}>
      <div className={styles.filterContainer}>
        <div className={styles.filterTitle}>Фильтр по типу:</div>
        <div className={styles.filterButtons}>
          {filters.map((filter) => (
            <button
              key={filter.id}
              className={`${styles.filterButton} ${
                activeFilter === filter.id ? styles.filterButtonActive : ''
              }`}
              onClick={() => onFilterChange(filter.id)}
            >
              <span className={styles.filterLabel}>{filter.label}</span>
              <span className={styles.filterCount}>{filter.count}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;